import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
const TestimonialSection = ({ themeData }: any) => {
  return (
    <>
      {' '}
      <section className="testimonial-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <span className="yellow-btn">
                  {themeData?.theme_3?.home?.section_12?.sub_heading_top}
                </span>
                <h2
                  style={{
                    color: `#${themeData?.theme_3?.home?.section_12?.h2color}`,
                  }}
                >
                  {themeData?.theme_3?.home?.section_12?.title}
                </h2>
                <p
                  style={{
                    color: `#${themeData?.theme_3?.home?.section_12?.paracolor}`,
                  }}
                >
                  {themeData?.theme_3?.home?.section_12?.paragraph}
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12">
              <Swiper
                spaceBetween={15}
                navigation={true}
                modules={[Navigation]}
                breakpoints={{
                  640: {
                    slidesPerView: 1,
                  },
                  768: {
                    slidesPerView: 2,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                }}
                className="home-slider"
              >
                {themeData?.theme_3?.home?.section_12?.review_card.map(
                  (items: any) => {
                    return (
                      <SwiperSlide>
                        <div className="testimonial-card">
                          <div className="profile-user">
                            <a className="profile-user-img">
                              <img
                                src={items.reviewer_pic}
                                className="rounded-circle"
                                alt=""
                              />
                            </a>
                            <div className="profile-user-info">
                              <h6>
                                <a
                                  style={{
                                    color: `#${themeData?.theme_3?.home?.section_12?.h3color}`,
                                  }}
                                >
                                  {items.reviewer_name}
                                </a>
                              </h6>
                              <div className="profile-rating">
                                <span className="secondary-text">
                                  <i className="fas fa-star"></i>
                                  <i className="fas fa-star"></i>
                                  <i className="fas fa-star"></i>
                                  <i className="fas fa-star"></i>
                                  <i className="fas fa-star"></i>
                                </span>
                                <span>{items.rating}</span>
                              </div>
                            </div>
                          </div>
                          <h5
                            style={{
                              color: `#${themeData?.theme_3?.home?.section_12?.h3color}`,
                            }}
                          >
                            {items.review_highlight}
                          </h5>
                          <p
                            style={{
                              color: `#${themeData?.theme_3?.home?.section_12?.paracolor}`,
                            }}
                          >
                            {items.review}
                          </p>
                        </div>
                      </SwiperSlide>
                    );
                  }
                )}
              </Swiper>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="load-more mt-5 d-none">
                <p className="d-block mb-4">
                  {
                    themeData?.theme_3?.home?.section_12
                      ?.review_bottom_paragraph
                  }
                </p>
                <a
                  href="#book-now"
                  className="btn title-btn ms-2 hover-btn"
                  style={{
                    background: `#${themeData?.theme_3?.home?.section_12?.btn_group?.btn1?.bg_color}`,
                    color: `#${themeData?.theme_3?.home?.section_12?.btn_group?.btn1?.color}`,
                  }}
                >
                  {themeData?.theme_3?.home?.section_12?.btn_group?.btn1?.text}
                  <i className="uil uil-arrow-circle-right ms-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>{' '}
    </>
  );
};

export default TestimonialSection;
